import type { YourRentalPropertyDto } from '@zg-rentals/ts-your-rental-api-client';

export const isEmptyRental = (property: YourRentalPropertyDto): boolean => {
  const { creditReportingSection, paymentSection, leaseSection, propertyConditionSection } = property;
  const hasPaymentsUpsell = !creditReportingSection && !!paymentSection?.upsellCardType;
  const hasLeaseUpsell = !!leaseSection?.upsellCardType;
  const hasPropertyConditionUpsell = !!propertyConditionSection?.upsellCardType;

  // A rental is empty if all sections show upsells
  return hasPaymentsUpsell && hasLeaseUpsell && hasPropertyConditionUpsell;
};

export const hasEmptyRental = (isLoggedIn: boolean, allProperties: Array<YourRentalPropertyDto>): boolean => {
  if (!isLoggedIn || !allProperties.length) {
    return false;
  }
  return allProperties.some((property) => isEmptyRental(property));
};
